/**
 * Loader component using react-spinners and framer-motion
 * @returns <Loader />
 */

import { motion } from "framer-motion";
import { BarLoader } from "react-spinners";

const Loader = () => {
    return (
        <motion.div style={{ height: "100vh", weight: "100vw", display: "flex", justifyContent: "center", alignItems: "center" }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            <BarLoader />
        </motion.div>
    )
}

export default Loader